export default __webpack_public_path__ + "static/media/affiliate blue 1.02ea6124.svg";